import { loadStripe, Stripe } from '@stripe/stripe-js';
import { toastMessages } from '../constants/errorMessages';
import { BankAccountTokenDetails } from '../types/interfaces/stripeConnect.interfaces';

const publishableKey = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY ?? '';

let stripePromise: Promise<Stripe | null> | null = null;

export const getStripe = (): Promise<Stripe | null> => {
  if (!publishableKey) return Promise.resolve(null);
  if (!stripePromise) {
    stripePromise = loadStripe(publishableKey).catch((error: unknown) => {
      stripePromise = null;
      throw error;
    });
  }
  return stripePromise;
};

export const createBankAccountToken = async (details: BankAccountTokenDetails): Promise<string> => {
  const stripe = await getStripe();
  if (!stripe) {
    throw new Error(toastMessages.STRIPE_PUBLISHABLE_KEY_MISSING);
  }

  const { token, error } = await stripe.createToken('bank_account', {
    country: 'US',
    currency: 'usd',
    account_holder_name: details.accountHolderName,
    account_holder_type: details.accountHolderType,
    routing_number: details.routingNumber,
    account_number: details.accountNumber,
  });

  if (error?.code === 'account_number_invalid') {
    throw new Error(toastMessages.STRIPE_ACCOUNT_NUMBER_INVALID);
  }

  if (error?.code === 'routing_number_invalid') {
    throw new Error(toastMessages.STRIPE_ROUTING_NUMBER_INVALID);
  }

  if (error || !token?.id) {
    throw new Error(toastMessages.SOMETHING_WENT_WRONG);
  }

  return token.id;
};
